import { useEffect, useState } from "react";
import { getProductsUrl } from "../../../config/stripeConfig";
import type { SubscribeCatalogProduct } from "../types";

export function useSubscribeCatalog() {
  const [catalogProducts, setCatalogProducts] = useState<
    SubscribeCatalogProduct[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);
    setError(false);

    fetch(getProductsUrl())
      .then((res) => {
        if (!res.ok) throw new Error(`products ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        setCatalogProducts(Array.isArray(data?.products) ? data.products : []);
        setIsLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setCatalogProducts([]);
        setError(true);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { catalogProducts, isLoading, error };
}
